import { render, staticRenderFns } from "./2fa-activation.vue?vue&type=template&id=189cff08&scoped=true&"
import script from "./2fa-activation.vue?vue&type=script&lang=js&"
export * from "./2fa-activation.vue?vue&type=script&lang=js&"
import style0 from "./2fa-activation.vue?vue&type=style&index=0&id=189cff08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189cff08",
  null
  
)

export default component.exports